import { login } from '../../lib/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import { getUser } from '../../lib/user';
import { authActions } from '../slices/auth-slice';
const AUTH_DATA = 'car_conf_auth';
const REMEMBER_ME = 'rememberMe';

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ email, password, rememberMe }) => {
    const data = await login(email, password);

    message.success('You are logged in.');

    return { data, rememberMe };
  }
);

export const getSelf = createAsyncThunk(
  'auth/getSelf',
  async (userId, { dispatch, rejectWithValue }) => {
    try {
      const user = await getUser(userId);

      return user;
    } catch (err) {
      const { code } = err.response.data;
      code === 404 && dispatch(logoutUser());

      return rejectWithValue(err.response.data);
    }
  }
);

export const logoutUser = () => {
  return (dispatch) => {
    localStorage.removeItem(AUTH_DATA);
    localStorage.removeItem(REMEMBER_ME);

    sessionStorage.removeItem(AUTH_DATA);

    dispatch(authActions.logoutHandler());
  };
};
